/**
 * Helper clavier partagé pour les échelles de notation (rating / NPS).
 *
 * a11y (WCAG 2.1.1) : les échelles se comportent comme un `radiogroup` —
 * navigation ←/→/↑/↓ entre valeurs, Home/End aux extrêmes. Pure function,
 * utilisée par RatingInput, NPSInput et le render inline de MultiStepFormVote.
 *
 * Renvoie la prochaine valeur, ou `null` si la touche n'est pas une touche
 * de navigation (l'appelant ne fait alors rien — pas de preventDefault).
 */
export function nextRatingValue(
  key: string,
  current: number | null,
  min: number,
  max: number,
): number | null {
  const base = current ?? min;
  switch (key) {
    case "ArrowRight":
    case "ArrowUp":
      return Math.min(max, base + 1);
    case "ArrowLeft":
    case "ArrowDown":
      return Math.max(min, base - 1);
    case "Home":
      return min;
    case "End":
      return max;
    default:
      return null;
  }
}
